import {
  AutocompleteInput,
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  FormTab,
  FunctionField,
  List,
  SearchInput,
  SelectInput,
  TextField,
} from "react-admin";
import { useCommonLabels } from "../i18n/hooks";
import { FilePreviewLink } from "../ui/fileUpload";
import { FormSection } from "../ui/forms/FormSection";
import { DescriptionLangFields, TitleLangFields } from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";
import { LocalizedFileControls, LocalizedFileLangField } from "../ui/forms/LocalizedFileInput";
import { normalizeContentRecord } from "../ui/forms/normalizeMedia";

const MUSIC_CATEGORIES = [
  { id: "relax", name: "Расслабление" },
  { id: "lullaby", name: "Колыбельная" },
  { id: "nature", name: "Звуки природы" },
  { id: "sleep", name: "Для сна" },
];

const filters = [
  <SearchInput key="q" source="q" alwaysOn />,
  <SelectInput key="category" source="Category" choices={MUSIC_CATEGORIES} emptyText="Все категории" />,
];

const PhMusicForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Настройки">
          <AutocompleteInput
            source="Category"
            label="Категория"
            choices={MUSIC_CATEGORIES}
            helperText="Группа трека — выберите из списка или введите свою"
            onCreate={async (filter) => (filter ? { id: filter, name: filter } : undefined)}
            fullWidth
          />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
        <FormSection title="Медиа">
          <LocalizedFileControls
            baseSource="Filename"
            label={c.filename}
            kind="audio"
            accept="audio/*"
            helperText="MP3 — загрузка через файловый сервис"
          />
          <LocalizedFileControls
            baseSource="Image"
            label={c.image}
            kind="image"
            helperText="Обложка JPG/PNG"
          />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <TitleLangFields lang="AZ" titleRequired />
        <DescriptionLangFields lang="AZ" rows={2} />
        <LocalizedFileLangField
          baseSource="Filename"
          lang="AZ"
          label={c.filename}
          kind="audio"
          accept="audio/*"
        />
        <LocalizedFileLangField baseSource="Image" lang="AZ" label={c.image} kind="image" />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <TitleLangFields lang="RU" titleRequired />
        <DescriptionLangFields lang="RU" rows={2} />
        <LocalizedFileLangField
          baseSource="Filename"
          lang="RU"
          label={c.filename}
          kind="audio"
          accept="audio/*"
        />
        <LocalizedFileLangField baseSource="Image" lang="RU" label={c.image} kind="image" />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <TitleLangFields lang="EN" titleRequired />
        <DescriptionLangFields lang="EN" rows={2} />
        <LocalizedFileLangField
          baseSource="Filename"
          lang="EN"
          label={c.filename}
          kind="audio"
          accept="audio/*"
        />
        <LocalizedFileLangField baseSource="Image" lang="EN" label={c.image} kind="image" />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhMusicList = () => {
  const c = useCommonLabels();
  return (
    <List filters={filters} sort={{ field: "Id", order: "DESC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="Id" label="ID" />
        <TextField source="TitleRU" label="Title" />
        <FunctionField
          label={c.filename}
          render={(record: { Filename?: string }) => <FilePreviewLink value={record.Filename} />}
        />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhMusicEdit = () => (
  <Edit mutationMode="pessimistic" transform={normalizeContentRecord}>
    <PhMusicForm />
  </Edit>
);

export const PhMusicCreate = () => (
  <Create transform={normalizeContentRecord}>
    <PhMusicForm />
  </Create>
);
